<template>
  <MainLayout>
    <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
      <template v-for="tab in tabs">
        <v-tab :key="tab.name" :to="{ name: tab.name }" ripple>{{ $t(tab.label) }}</v-tab>
      </template>
    </v-tabs>
    <router-view></router-view>
  </MainLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page'

export default {
  data() {
    return {
      currentView: 'agent-overview'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),

    isKmbAgent() {
      return [...PAGE.KMB_AGENT].includes(this.selectedBot.pageid)
    },
    isDisplayTabAgentPerformance() {
      if (this.isKmbAgent) {
        return true
      }

      return (
        this.$store.state.privilege &&
        ['all', 'supervisor', 'superadmin'].includes(this.$store.state.privilege.role)
      )
    },
    tabs() {
      return [
        {
          name: 'ticket3-agent-overview',
          label: 'agent overview'
        },
        ...(this.isDisplayTabAgentPerformance && [
          {
            name: 'ticket3-agent-performance-detail',
            label: 'agent performance'
          }
        ]),
        ...(this.$store.state.privilege &&
        ['all', 'superadmin'].includes(this.$store.state.privilege.role)
          ? [
              {
                name: 'ticket3-admin-management',
                label: 'agent management'
              }
            ]
          : []),
        ...(this.isZwizAdmin()
          ? [
              {
                name: 'ticket3-admin-management-priority',
                label: 'agent priority'
              },
              {
                name: 'ticket3-admin-management-iframe',
                label: 'agent management (beta)'
              }
            ]
          : [])
      ].filter(Boolean)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/LayoutAgentManagement.vue